var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6408 8.34163L12.4075 11.2583C12.32 12.1508 12.25 12.8333 10.6692 12.8333H3.33083C1.75 12.8333 1.68 12.1508 1.5925 11.2583L1.35916 8.34163C1.3125 7.85746 1.46416 7.40829 1.73833 7.06413C1.74416 7.05829 1.74416 7.05829 1.75 7.05246C2.07083 6.66163 2.555 6.41663 3.0975 6.41663H10.9025C11.445 6.41663 11.9233 6.66163 12.2383 7.04079C12.2442 7.04663 12.25 7.05246 12.25 7.05829C12.5358 7.40246 12.6933 7.85163 12.6408 8.34163Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04166 6.66754V3.66337C2.04166 1.68004 2.53749 1.1842 4.52082 1.1842H5.26166C6.00249 1.1842 6.17166 1.40587 6.45166 1.7792L7.19249 2.77087C7.37916 3.01587 7.48999 3.16754 7.98582 3.16754H9.47332C11.4567 3.16754 11.9525 3.66337 11.9525 5.6467V6.69087",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50082 9.91663H8.49916",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.9b69743a5220865ff542bda7f59e36e2.svg";
export { ForwardRef as ReactComponent };